// This JavaScript requires jQuery UI Widget support.

if (typeof (window.advertising) === 'undefined') {
    window.advertising = {};
}

// Widget for slideout forms
$.widget("advertising.slideoutForm", {
    _isAnimating: false,
    _isShown: false,

    options: {
        // jQuery selector if the form needs to be re-parented elsewhere before displaying.
        container: undefined,

        // Duration in milliseconds of the sliding animation.
        duration: 300,

        // Function to call when animation completes
        onAnimationComplete: $.noop
    },

    _init: function () {

        if (typeof (advertising.slideoutForm) === 'undefined') {
            window.advertising.slideoutForm = {
                allSlideouts: []
            };
        }

        if (this.options.container) {
            this.element.prependTo($(this.options.container));
        }

        advertising.slideoutForm.allSlideouts.push(this);
    },

    toggle: function () {
        this._isShown ? this.hide() : this.show();
    },

    show: function (removeHidden) {
        var me = this;
        var otherSlideouts;
        if (!me._isShown && !me._isAnimating) {
            me._isAnimating = true;
            $.each(advertising.slideoutForm.allSlideouts, function () {
                this.hide();
            });

            me.element.slideDown(me.options.duration, function () {
                me._isAnimating = false;
                me._isShown = true;
                me.options.onAnimationComplete(true);
            });

            // this is sort of a hack to remove the DOM elements that would otherwise badly interfere if kept in the page (e.g. CP iframes)
            if (removeHidden) {
                // since we've just hidden all the slideouts and only shown this one, we'll have to remove all of them except this
                otherSlideouts = $.grep(advertising.slideoutForm.allSlideouts, function (item) {
                    return item !== me;
                });

                $.each(otherSlideouts, function () {
                    var elem = $(this.element);
                    this.destroy();
                    elem.remove();
                });

                advertising.slideoutForm.allSlideouts = [ me ];
            }
        }
    },

    hide: function () {
        var me = this;
        if (me._isShown && !me._isAnimating) {
            me._isAnimating = true;
            me.element.slideUp(me.options.duration, function () {
                me._isAnimating = false;
                me._isShown = false;
                me.options.onAnimationComplete(false);
            });
        }
    }
});
